import Vue from 'vue'
import store from '@/store/store'
// import UILoading from './Loading.vue'
// import UIIntroduce from './Introduce.vue'
import UIPosition from './position.vue'
import UIAntiques from './Antiques.vue'
import UIDetail from './Detail.vue'
import UIFullScreen from './fullScreen.vue'




// const Loading = Vue.extend(UILoading)
// const Introduce = Vue.extend(UIIntroduce)

const Position = Vue.extend(UIPosition)
const Antiques = Vue.extend(UIAntiques)
const Detail = Vue.extend(UIDetail)
const FullScreen = Vue.extend(UIFullScreen)


/* export function $tips(data={}) {
    let instance = new Tips({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}

export function $alert(data={}) {
    let instance = new Alert({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}

export function $confirm(data={}) {
    let instance = new Confirm({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}

export function $message(data={}) {
    let instance = new Message({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
} */
export function $showFullScreen(data={}) {
    let instance = new FullScreen({
        data,store
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}
export function $showDetail(data={}) {
       let detail = new Detail({
        data,store
    }).$mount();     
        document.body.appendChild(detail.$el)   
    Vue.nextTick(() => {
        instance.show = true
    })
}
let showposition = true;
let position = '';
export function $showPosition(data={}) {
    if(showposition) {
        position = new Position({
        data
    }).$mount()
    showposition = false;
    document.body.appendChild(position.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
    }else {
        document.body.removeChild(position .$el);
        showposition = true;
    }
    
}
let showAntiques = true;
let instance ='';
export function $showAntiques(data={}) {
    
    if(showAntiques) {
        instance = new Antiques({
        data
    }).$mount()
    showAntiques = false;
    document.body.appendChild(instance.$el);
   

    Vue.nextTick(() => {
        instance.show = true
    })
    }else {
        document.body.removeChild(instance.$el);
        showAntiques = true;
    }
    
}
// export function $introduce(data={}) {
//     let instance = new Introduce({
//         data
//     }).$mount()

//     document.body.appendChild(instance.$el)

//     Vue.nextTick(() => {
//         instance.show = true
//     })
// }

/* let loadingInstance = ''
export function $showLoading(data={}) {
    if (loadingInstance) {
        return
    }
    loadingInstance = new Loading({
        data
    }).$mount()

    document.body.appendChild(loadingInstance.$el)

    Vue.nextTick(() => {
        loadingInstance.show = true
    })
}

export function $hideLoading() {
    if (loadingInstance) {
        document.body.removeChild(loadingInstance.$el)
        loadingInstance = ''
    }
} */



/* let broadcastInstance = ''
export function $showBroadcast(data={}) {
    if (broadcastInstance) {
        return
    }
    broadcastInstance = new Broadcast({
        data
    }).$mount()

    document.body.appendChild(broadcastInstance.$el)

    Vue.nextTick(() => {
        broadcastInstance.show = true
    })
}

export function $hideBroadcast() {
    if (broadcastInstance) {
        document.body.removeChild(broadcastInstance.$el)
        broadcastInstance = ''
    }
} */
